import React from 'react';
import { Link } from 'react-router-dom';
import { useInstitucion } from '../context/InstitucionContext';

/**
 * Encabezado de las páginas públicas (inicio y categoría): gradiente institucional, logo,
 * título, subtítulo y la onda inferior.
 *
 * La onda lleva `preserveAspectRatio="none"` y alto fijo (`h-8 sm:h-12`): con `h-auto` escalaba
 * con el ancho de la ventana (60px de viewBox × ancho/1440) y en pantallas grandes crecía hasta
 * tapar el logo y el subtítulo. El padding inferior del contenido reserva su espacio.
 */
const HeroHeader = ({ titulo, subtitulo }) => {
  const { institucion, paleta: colors, ruta } = useInstitucion();

  return (
    <header className="relative overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          background: `linear-gradient(135deg, ${colors.headerGradientStart}, ${colors.headerGradientMid}, ${colors.headerGradientEnd})`,
        }}
      />
      <div className="absolute inset-0 bg-pattern opacity-10" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-16 sm:pt-14 sm:pb-20">
        <div className="flex items-center gap-5">
          {institucion && institucion.logoUrl && (
            <Link to={ruta('/')} className="flex-shrink-0" title="Ir al inicio">
              <img
                src={`${process.env.PUBLIC_URL}${institucion.logoUrl}`}
                alt={`Logo ${institucion.nombreCorto}`}
                className="h-14 sm:h-16 drop-shadow-lg"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            </Link>
          )}
          <div>
            <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight drop-shadow-md">
              {titulo}
            </h1>
            {subtitulo && (
              <p className="mt-1.5 text-white/85 text-sm sm:text-base font-light">
                {subtitulo}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0">
        <svg
          viewBox="0 0 1440 60"
          fill="none"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-8 sm:h-12 block"
        >
          <path d="M0 60V30C240 0 480 0 720 30C960 60 1200 60 1440 30V60H0Z" fill="#F9FAFB" />
        </svg>
      </div>
    </header>
  );
};

export default HeroHeader;
